import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'filterChips',
    standalone: false
})
export class FilterChipsPipe implements PipeTransform {

  transform(value: string[]): string[][] {
    return value.map(item => item.split('='));
  }

}
